// extracted by mini-css-extract-plugin
module.exports = {"container":"Section1-module--container--1UzV4"};